import React from "react";

interface KeyPhrasesCardProps {
  phrases: string[];
}

/**
 * Displays a list of key phrases, each in a quoted gray chip.
 */
const KeyPhrasesCard: React.FC<KeyPhrasesCardProps> = ({ phrases }) => (
  <div className="flex flex-col gap-2 rounded-[10px] border border-[#E6E6E6] bg-white p-4">
    <p className="text-[11px] font-bold uppercase tracking-[0.6px] text-[#5C5C5C]">
      Key Phrases
    </p>
    <div className="flex flex-col gap-2">
      {phrases.map((phrase, idx) => (
        <div
          key={idx}
          className="flex items-center gap-1 rounded bg-[#F7F9FA] px-3 py-2"
        >
          <span className="text-[13px] font-bold text-[#A8A8A8]">&ldquo;</span>
          <span className="text-[13px] text-[#3D3D3D]">{phrase}</span>
          <span className="text-[13px] font-bold text-[#A8A8A8]">&rdquo;</span>
        </div>
      ))}
    </div>
  </div>
);

export default KeyPhrasesCard;
